import React from 'react';
import {
  Box,
  Flex,
  Text,
  Icon,
  chakra,
  useRadio,
  FormControl,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import CustomRadio from './CustomRadio';

const FormRadioOption = ({
  icon,
  title,
  description,
  value,
  name,
  isSelected,
  onChange,
}) => {
  const { getInputProps, getCheckboxProps } = useRadio({
    value,
    name,
    isChecked: isSelected,
    onChange: () => onChange(value),
  });

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  const getDescriptionColor = () => {
    if (isSelected) {
      if (value === 'ach') { return 'green.300'; }
      if (value === 'credit') { return 'red.300'; }
      if (value === 'debit') { return 'green.300'; }
    }
    return '#555555';
  };

  return (
    <chakra.label w="100%">
      <FormControl>
        <input {...input} />
        <Box
          {...checkbox}
          display="flex"
          alignItems="center"
          padding="16px"
          justifyContent="space-between"
          cursor="pointer"
          transition="all 0.2s"
          w="100%"
          gap="10px"
        >
      <Flex align="top" gap={3}>
          <Icon as={icon} boxSize={6} />
          <Box>
            <Text
              fontFamily="Helvetica"
              fontWeight="400"
              fontSize="16px"
              lineHeight="100%"
              letterSpacing="0%"
              color="#000000"
            >
              {title}
            </Text>
            <Text
              variant="sm"
              color={getDescriptionColor()}
            >
              {description}
            </Text>
          </Box>
      </Flex>

          <CustomRadio
            name={name}
            value={value}
            isChecked={isSelected}
            onChange={() => onChange(value)}
          />
        </Box>
      </FormControl>
    </chakra.label>
  );
};

FormRadioOption.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FormRadioOption;
